var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFavorites = function SvgFavorites(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m9.344 13.899 3.937 2.5c.508.32 1.133-.157.985-.743l-1.14-4.484a.68.68 0 0 1 .226-.688l3.53-2.945c.462-.383.227-1.156-.374-1.195l-4.61-.297a.65.65 0 0 1-.57-.422L9.61 1.297a.648.648 0 0 0-1.218 0L6.672 5.625a.65.65 0 0 1-.57.422l-4.61.297c-.601.039-.836.812-.375 1.195l3.532 2.945a.68.68 0 0 1 .226.688L3.82 15.328c-.18.703.57 1.274 1.172.89l3.664-2.32a.64.64 0 0 1 .688 0"
  })));
};
export default SvgFavorites;